import { JSX, useRef } from 'react';
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Stack,
  useBreakpointValue,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import _ from 'lodash';

import { IOption } from 'api-paths-cas';

interface ViewDropdownProps {
  label: string;
  options: IOption[];
  defaultOption: IOption;
  onSelect: (option: IOption) => void;
}

export const ViewDropdown = (props: ViewDropdownProps): JSX.Element => {
  const { label, options, defaultOption, onSelect } = props;

  const defaultOptionRef = useRef<HTMLButtonElement | null>(null);

  const isLargeScreen = useBreakpointValue({ base: false, md: true });

  const id = _.snakeCase(label);

  return (
    <Stack spacing={{ base: 2, md: 0 }} className="MenuContainer" mb={{ base: 6, md: 0 }}>
      <Menu placement={isLargeScreen ? 'bottom-end' : 'bottom-start'} initialFocusRef={defaultOptionRef}>
        <Box
          id={`${id}_label`}
          color={{ md: 'muted' }}
          fontSize={{ base: 'md', md: 'xs' }}
          lineHeight={{ base: 5, md: 4 }}
          px={{ base: 0, md: 2 }}
        >
          {label}
        </Box>

        <MenuButton
          aria-labelledby={`${id}_label ${id}_value`}
          as={Button}
          variant={{ base: 'secondary', md: 'ghost' }}
          size={{ base: 'md', md: 'xs' }}
          rightIcon={<FontAwesomeIcon className="utility-icon" icon={faAngleDown} />}
          textAlign={'left'}
        >
          <span id={`${id}_value`}>{defaultOption?.label ?? `Select ${label}`}</span>
        </MenuButton>

        <MenuList fontSize="sm" lineHeight={5} maxHeight={'70vh'}>
          <MenuOptionGroup defaultValue={defaultOption?.value} type="radio">
            {options.map((option, index) => (
              <MenuItemOption
                ref={option.value === defaultOption?.value ? defaultOptionRef : null}
                key={index}
                value={option.value}
                onClick={() => onSelect(option)}
              >
                {option.label}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Stack>
  );
};
